import { CText } from '../@shared/models/text.model';
import { Style } from '../@shared/models/style.model';
import { Iconable } from '../@shared/models/iconable.model';

export class LFPDATA {
    leftButton: CText;
    rightButton: CText;
    active: number;
    feed: Array<Feed>;
    cross: Iconable;

    constructor() {
        this.leftButton = { text: '' };
        this.rightButton = { text: '' };
        this.active = 0;
        this.feed = [];
        this.cross = { icon: '', link: '' };
    }
}

export interface Feed {
    feed: Array<FeedData>;
    text: string;
}

export interface FeedData {
    layout: string;
    text: string;
    feed: Array<Style>;
}
